export const isActualProduct = (productId: number | null | undefined): boolean => !!productId && productId > 0;
